export const contactsData = {
    email: 'altruong@berkeley.edu',
    phone: '',
    address: 'San Francisco, CA',

    sheetAPI: ''
}